var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.43268C2 2.64165 2.65752 2 3.46864 2H20.4053C21.2164 2 21.8739 2.64165 21.8739 3.43268V20.5673C21.8739 21.3586 21.2164 22 20.4053 22H3.46864C2.65752 22 2 21.3586 2 20.5673V3.43268Z",
    fill: "#006699"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.02444 18.7422V9.71107H5.02266V18.7422H8.02444ZM6.52354 8.47802C7.57032 8.47802 8.22185 7.78453 8.22185 6.91787C8.20234 6.0317 7.57032 5.35746 6.5434 5.35746C5.51658 5.35746 4.84521 6.0317 4.84521 6.91787C4.84521 7.78453 5.49661 8.47802 6.50397 8.47802H6.52354Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6853 18.7422H12.6871V13.6988C12.6871 13.4289 12.7066 13.1593 12.7858 12.9663C13.0028 12.427 13.4967 11.8685 14.326 11.8685C15.4122 11.8685 15.8467 12.6967 15.8467 13.9108V18.7422H18.8482V13.5639C18.8482 10.7899 17.3673 9.49915 15.3924 9.49915C13.773 9.49915 13.0621 10.4043 12.6671 11.0208H12.6871V9.71107H9.68538C9.72478 10.5585 9.6853 18.7422 9.6853 18.7422Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.c823bf0023167fdb83d1f8ddbf502c1f.svg";
export { ForwardRef as ReactComponent };